import {
  Button,
  CircularProgress,
  FormHelperText,
  FormLabel,
  TextField,
  Typography,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { Controller, useForm, useFieldArray } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { FormStyle } from "./Marketing/FormStyle";
import QuillEditor from "./Marketing/QuillEditor";
import { getCookie } from "../../../Utils/GetCookies";

function RecordingCourseForm(props) {
  const {
    handleSubmit,
    control,
    getValues,
    setValue,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      myRadio: props.edit === "edit" ? props.editPost.video_type : "",
      your_learn:
        props.edit === "edit"
          ? JSON.parse(props.editPost.your_learn).map((data) => ({
              name: data,
            }))
          : [],

      modules:
        props.edit === "edit"
          ? JSON.parse(props.editPost.modules).map((module) => ({
              title: module.title,
              totalHours: module.totalHours,
              items: module.items.map((item) => ({
                name: item.name,
                hour: item.hour,
              })),
            }))
          : [{ title: "", items: [{ name: "", hour: "" }] }],
    },
  });

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const backendURL = `${process.env.REACT_APP_BACKEND_ADMIN}recording-course`;
  const [fileUrlThumbnail, setfileUrlThumbnail] = useState();
  const [fileUrlImage, setfileUrlImage] = useState();

  const [videoUrl, setVideoUrl] = useState(null);

  const fileThumbnail = watch("fileUploadThumbnail");
  const fileImage = watch("imageFile");

  const fileVideo = watch("videoFile");

  // Main modules field array
  const {
    fields: moduleFields,
    append: appendModule,
    remove: removeModule,
  } = useFieldArray({
    control,
    name: "modules",
  });

  // Component to manage items within a module
  const ModuleItemsManager = ({ control, moduleIndex, items }) => {
    const { fields, append, remove } = useFieldArray({
      control,
      name: `modules.${moduleIndex}.items`,
    });

    const addNewItem = () => {
      append({ name: "", hour: "" });
    };

    const removeItem = (itemIndex) => {
      if (fields.length > 1) {
        remove(itemIndex);
      }
    };

    return (
      <>
        {fields.map((item, itemIndex) => (
          <Box key={item.id} sx={{ mb: 2 }}>
            <Controller
              name={`modules.${moduleIndex}.items.${itemIndex}.name`}
              control={control}
              defaultValue={item.name}
              rules={{
                required: {
                  value: true,
                  message: "*Item content is required",
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label={`Item ${itemIndex + 1}`}
                  variant="standard"
                  error={
                    !!errors.modules?.[moduleIndex]?.items?.[itemIndex]?.name
                  }
                  helperText={
                    errors.modules?.[moduleIndex]?.items?.[itemIndex]?.name
                      ?.message
                  }
                  sx={{ bgcolor: "rgb(231 239 254)", mt: "1rem" }}
                />
              )}
            />
            <Controller
              name={`modules.${moduleIndex}.items.${itemIndex}.hour`}
              control={control}
              defaultValue={item.hour}
              rules={{
                required: {
                  value: true,
                  message: "*Hours is required",
                },
                // pattern: {
                //   value: /^[0-9]+$/,
                //   message: "Please enter a valid number",
                // },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  // type="number"
                  fullWidth
                  label={`Item ${itemIndex + 1} - Hours`}
                  variant="standard"
                  error={
                    !!errors.modules?.[moduleIndex]?.items?.[itemIndex]?.hour
                  }
                  helperText={
                    errors.modules?.[moduleIndex]?.items?.[itemIndex]?.hour
                      ?.message
                  }
                  sx={{ bgcolor: "rgb(231 239 254)", mt: "1rem" }}
                />
              )}
            />
          </Box>
        ))}
        <Box display="flex" gap={2}>
          <Button variant="contained" onClick={addNewItem}>
            Add Item
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => removeItem(fields.length - 1)}
            disabled={fields.length <= 1}
          >
            Remove Item
          </Button>
        </Box>
      </>
    );
  };

  const addNewModule = () => {
    appendModule({
      title: "",
      totalHours: "",
      items: [{ name: "", hour: "" }],
    });
  };

  const removeModuleField = (index) => {
    removeModule(index);
  };

  const {
    fields: fieldList,
    remove: removeList,
    append: appendList,
  } = useFieldArray({ control, name: "your_learn" });

  const addField = () => {
    appendList({ name: "", hour: "" });
  };

  const removeField = () => {
    removeList(fieldList.length - 1);
  };

  const quillRef = useRef();
  const requirementRef = useRef();
  const courseIncludeRef = useRef();

  useEffect(() => {
    if (props.edit === "edit") {
      setfileUrlThumbnail(
        `${process.env.REACT_APP_BACKEND_URL}storage/${props.editPost.vd_thumbnail}`
      );
      setVideoUrl(
        `${process.env.REACT_APP_BACKEND_URL}storage/${props.editPost.video_file}`
      );

      setfileUrlImage(
        `${process.env.REACT_APP_BACKEND_URL}storage/${props.editPost.image_file}`
      );

      let edit_req = JSON.parse(props.editPost.requirement);
      let req_editor = requirementRef.current.getEditor();
      req_editor.setContents(edit_req?.ops);

      let edit_des = JSON.parse(props.editPost.description);
      let des_editor = quillRef.current.getEditor();
      des_editor.setContents(edit_des?.ops);

      let edit_ci = JSON.parse(props.editPost.course_includes);
      let ci_editor = courseIncludeRef.current.getEditor();
      ci_editor.setContents(edit_ci?.ops);
    }
  }, [props, setValue]);

  useEffect(() => {
    if (fileThumbnail !== undefined && fileThumbnail !== "") {
      setfileUrlThumbnail("");
      setfileUrlThumbnail(URL.createObjectURL(fileThumbnail));
    }
    if (fileVideo !== undefined && fileVideo !== "") {
      setVideoUrl("");
      setVideoUrl(URL.createObjectURL(fileVideo));
    }

    if (fileImage !== undefined && fileImage !== "") {
      setfileUrlImage("");
      setfileUrlImage(URL.createObjectURL(fileImage));
    }
  }, [fileThumbnail, fileVideo, fileImage]);

  const addPost = async (request) => {
    setLoading(true);
    let token = await getCookie("userToken");
    let config = { headers: { Authorization: "Bearer " + token } };

    try {
      const res = await axios.post(`${backendURL}`, request, config);
      if (res.status === 200) {
        if (res.data.errors) {
          swal({
            title: "Warning",
            text: res.data.errors[0],
            icon: "warning",
            button: "OK!",
          });
        } else {
          swal({
            title: "Success",
            text: res.data.message,
            icon: "success",
            button: "OK!",
          });
        }
        setLoading(false);
        navigate(-1);
      } else {
        swal({
          title: "Warning",
          text: res.data.message,
          icon: "warning",
          button: "OK!",
        });
        setLoading(false);
      }
    } catch (error) {
      swal({
        title: "Warning",
        text: error.message,
        icon: "warning",
        button: "OK!",
      });
      setLoading(false);
    }
  };

  const editPost = async (request) => {
    setLoading(true);
    let token = getCookie("userToken");
    request.append("_method", "PUT");
    let config = { headers: { Authorization: "Bearer " + token } };

    try {
      const res = await axios.post(
        `${backendURL}/${props.id}`,
        request,
        config
      );
      if (res.status === 200) {
        swal({
          title: "Success",
          text: res.data.message,
          icon: "success",
          button: "OK!",
          timer: 1500,
        });
        navigate(-1);
      } else {
        swal({
          title: "Warning",
          text: res.data.message,
          icon: "warning",
          button: "OK!",
        });
        setLoading(false);
        navigate(-1);
      }
    } catch (error) {
      swal({
        title: "Warning",
        text: error.message,
        icon: "warning",
        button: "OK!",
      });
      setLoading(false);
    }
  };

  const saveType = (data) => {
    const editText = quillRef.current.getEditor();
    const editRequirementText = requirementRef.current.getEditor();
    const editCourseIncludeText = courseIncludeRef.current.getEditor();

    const text = editText.getLength();
    const requirementText = editRequirementText.getLength();

    if (text === 1) {
      return;
    } else {
      const formData = new FormData();
      formData.append("title", data.title);
      formData.append("sub_title", data.sub_title);
      formData.append("last_update_at", data.last_update_at);
      formData.append("language", data.language);
      formData.append("instructor_info", data.instructorInfo);
      formData.append("course_content", data.courseContent);
      formData.append("is_active", data.status ? 1 : 0); // Add status to form data

      if (props.edit === "edit" && data.videoFile === undefined) {
        formData.append("video_file", videoUrl);
      } else {
        formData.append("video_file", data.videoFile);
      }

      if (props.edit === "edit" && data.fileUploadThumbnail === undefined) {
        formData.append("vd_thumbnail", fileUrlThumbnail);
      } else {
        formData.append("vd_thumbnail", data.fileUploadThumbnail);
      }

      if (props.edit === "edit" && data.imageFile === undefined) {
        formData.append("image_file", fileUrlImage);
      } else {
        formData.append("image_file", data.imageFile);
      }

      formData.append("description", JSON.stringify(editText.getContents()));
      formData.append(
        "requirement",
        JSON.stringify(editRequirementText.getContents())
      );
      formData.append(
        "course_includes",
        JSON.stringify(editCourseIncludeText.getContents())
      );
      formData.append("fees", data.fees);
      formData.append("oversea_fees", data.oversea_fees);

      // Process dynamic modules
      const modules = data.modules.map((module) => ({
        title: module.title,
        totalHours: module.totalHours,
        items: module.items.map((item) => ({
          name: item.name,
          hour: item.hour,
        })),
      }));
      formData.append("modules", JSON.stringify(modules));

      let your_learn = [];
      data.your_learn.forEach((d) => {
        your_learn = [...your_learn, d.name];
      });
      formData.append("your_learn", JSON.stringify(your_learn));

      props.edit === "edit" ? editPost(formData) : addPost(formData);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(saveType)}>
        {/* Title */}
        <Box sx={{ my: 2 }}>
          <Controller
            name="title"
            control={control}
            defaultValue={props.edit === "edit" ? props.editPost.title : ""}
            rules={{
              required: {
                value: true,
                message: "*Title is required",
              },
            }}
            render={({ field: { ref, ...field } }) => (
              <TextField
                {...field}
                inputRef={ref}
                id="title"
                type="text"
                fullWidth
                error={!!errors.title}
                label={<Typography variant="h6">Title</Typography>}
                InputProps={{
                  sx: {
                    ...FormStyle.inputStyle,
                  },
                }}
                helperText={errors?.title?.message}
              />
            )}
          />
        </Box>

        {/* Sub Title */}
        <Box sx={{ my: 2 }}>
          <Controller
            name="sub_title"
            control={control}
            defaultValue={props.edit === "edit" ? props.editPost.sub_title : ""}
            rules={{
              required: {
                value: true,
                message: "*Sub-Title is required",
              },
            }}
            render={({ field: { ref, ...field } }) => (
              <TextField
                {...field}
                inputRef={ref}
                id="sub_title"
                type="text"
                fullWidth
                error={!!errors.sub_title}
                label={<Typography variant="h6">Sub-Title</Typography>}
                InputProps={{
                  sx: {
                    ...FormStyle.inputStyle,
                  },
                }}
                helperText={errors?.sub_title?.message}
              />
            )}
          />
        </Box>
        {/* Course Last Update */}
        <Box sx={{ my: 2 }}>
          <Controller
            name="last_update_at"
            control={control}
            defaultValue={
              props.edit === "edit" ? props.editPost.last_update_at : ""
            }
            rules={{
              required: {
                value: true,
                message: "*Last_update_at is required",
              },
            }}
            render={({ field: { ref, ...field } }) => (
              <TextField
                {...field}
                inputRef={ref}
                id="last_update_at"
                type="date"
                fullWidth
                error={!!errors.last_update_at}
                label={<Typography variant="h6">Last update at</Typography>}
                InputProps={{
                  sx: {
                    ...FormStyle.inputStyle,
                  },
                }}
                helperText={errors?.last_update_at?.message}
              />
            )}
          />
        </Box>

        {/* Language */}
        <Box sx={{ my: 2 }}>
          <Controller
            name="language"
            control={control}
            defaultValue={props.edit === "edit" ? props.editPost.language : ""}
            rules={{
              required: {
                value: true,
                message: "*Language is required",
              },
            }}
            render={({ field: { ref, ...field } }) => (
              <TextField
                {...field}
                inputRef={ref}
                id="language"
                type="text"
                fullWidth
                error={!!errors.last_update_at}
                label={<Typography variant="h6">language</Typography>}
                InputProps={{
                  sx: {
                    ...FormStyle.inputStyle,
                  },
                }}
                helperText={errors?.language?.message}
              />
            )}
          />
        </Box>

        {/* Video Link */}
        <Box sx={{ my: 2 }}>
          <Controller
            name="instructorInfo"
            control={control}
            defaultValue={
              props.edit === "edit" ? props.editPost.instructor_info : ""
            }
            rules={{
              required: {
                value: true,
                message: "*Instructor Info is required",
              },
            }}
            render={({ field: { ref, ...field } }) => (
              <TextField
                {...field}
                inputRef={ref}
                id="instructorInfo"
                type="text"
                fullWidth
                error={!!errors.instructorInfo}
                label="Instructor Info"
                helperText={errors?.vidoeLink?.message}
                InputProps={{
                  sx: {
                    ...FormStyle.inputStyle,
                  },
                }}
              />
            )}
          />
        </Box>

        {/* Video File Upload */}
        <Box sx={{ my: 3 }}>
          <FormLabel sx={{ mr: 2 }}>Upload Video</FormLabel>
          <Controller
            name="videoFile"
            control={control}
            rules={{
              validate: (file) => {
                // Skip validation in edit mode if no file is uploaded
                if (props.edit === "edit" && !file) return true;

                // Validate file size if a file is uploaded
                return file && file.size <= 50 * 1024 * 1024 // 50MB in bytes
                  ? true
                  : "File size must not exceed 50MB";
              },
            }}
            render={({ field: { onChange } }) => (
              <label htmlFor="video-file">
                <input
                  accept="video/*"
                  style={{ display: "none" }}
                  id="video-file"
                  onChange={(event) => {
                    const file = event.target.files[0];
                    onChange(file);
                    setVideoUrl(file ? URL.createObjectURL(file) : null);
                  }}
                  type="file"
                />
                <Button variant="contained" component="span">
                  Upload Video
                </Button>
              </label>
            )}
          />
          {errors.videoFile && (
            <Typography variant="p" color="red" textAlign={"left"}>
              <small>{errors.videoFile.message}</small>
            </Typography>
          )}
        </Box>

        {videoUrl && (
          <Box sx={{ mt: 2 }}>
            <video
              controls
              autoPlay={false}
              alt="UploadVideo"
              src={videoUrl}
              width="400"
              height="200"
            />
          </Box>
        )}

        {/* Thumbnail Upload */}

        <Box sx={{ my: 3 }}>
          <FormLabel sx={{ mr: 2 }}>Upload Video Thumbnail</FormLabel>
          <Controller
            name="fileUploadThumbnail"
            control={control}
            rules={{
              required: {
                value: props.edit === "edit" ? false : true,
                message: "*Required file",
              },
            }}
            render={({ field: { onChange } }) => (
              <label htmlFor="file-video-thumbnail">
                <input
                  accept="image/*"
                  style={{ display: "none" }}
                  id="file-video-thumbnail"
                  onChange={(event) => onChange(event.target.files[0])}
                  type="file"
                />
                <Button variant="contained" component="span">
                  Upload Image
                </Button>
              </label>
            )}
          />
          {errors.fileUploadThumbnail && (
            <Typography variant="p" color="red" textAlign={"left"}>
              <small>{errors.fileUploadThumbnail.message}</small>
            </Typography>
          )}
        </Box>

        {fileUrlThumbnail && (
          <Box
            sx={{
              width: "30%",
              borderRadius: "1rem",
              p: 1,
              backgroundColor: "white",
            }}
          >
            <img
              src={fileUrlThumbnail}
              style={{ width: "100%" }}
              alt="UploadThumbnail"
            />
          </Box>
        )}

        {/* Image Upload */}

        <Box sx={{ my: 3 }}>
          <FormLabel sx={{ mr: 2 }}>Upload Image</FormLabel>
          <Controller
            name="imageFile"
            control={control}
            rules={{
              required: {
                value: props.edit === "edit" ? false : true,
                message: "*Required file",
              },
            }}
            render={({ field: { onChange } }) => (
              <label htmlFor="file-img">
                <input
                  accept="image/*"
                  style={{ display: "none" }}
                  id="file-img"
                  onChange={(event) => onChange(event.target.files[0])}
                  type="file"
                />
                <Button variant="contained" component="span">
                  Upload Image
                </Button>
              </label>
            )}
          />
          {errors.fileUploadThumbnail && (
            <Typography variant="p" color="red" textAlign={"left"}>
              <small>{errors.imageFile.message}</small>
            </Typography>
          )}
        </Box>

        {fileUrlImage && (
          <Box
            sx={{
              width: "30%",
              borderRadius: "1rem",
              p: 1,
              backgroundColor: "white",
            }}
          >
            <img
              src={fileUrlImage}
              style={{ width: "100%" }}
              alt="UploadThumbnail"
            />
          </Box>
        )}

        {/* Fees */}
        <Box sx={{ my: 2 }}>
          <Controller
            name="fees"
            control={control}
            defaultValue={props.edit === "edit" ? props.editPost.fees : ""}
            rules={{
              required: {
                value: true,
                message: "*Fees is required",
              },
            }}
            render={({ field: { ref, ...field } }) => (
              <TextField
                {...field}
                inputRef={ref}
                id="fees"
                type="number"
                fullWidth
                error={!!errors.fees}
                label={<Typography variant="h6">Fees</Typography>}
                InputProps={{
                  sx: {
                    ...FormStyle.inputStyle,
                  },
                }}
                helperText={errors?.fees?.message}
              />
            )}
          />
        </Box>

        {/* Oversea Fees */}
        <Box sx={{ my: 2 }}>
          <Controller
            name="oversea_fees"
            control={control}
            defaultValue={
              props.edit === "edit" ? props.editPost.oversea_fees : ""
            }
            rules={{
              required: {
                value: true,
                message: "*Oversea fees is required",
              },
            }}
            render={({ field: { ref, ...field } }) => (
              <TextField
                {...field}
                inputRef={ref}
                id="oversea_fees"
                type="number"
                fullWidth
                error={!!errors.oversea_fees}
                label={<Typography variant="h6">Oversea Fees</Typography>}
                InputProps={{
                  sx: {
                    ...FormStyle.inputStyle,
                  },
                }}
                helperText={errors?.oversea_fees?.message}
              />
            )}
          />
        </Box>

        {/* Course Content */}
        <Box sx={{ my: 2 }}>
          <Controller
            name="courseContent"
            control={control}
            defaultValue={
              props.edit === "edit" ? props.editPost.course_content : ""
            }
            rules={{
              required: {
                value: true,
                message: "*Course Content is required",
              },
            }}
            render={({ field: { ref, ...field } }) => (
              <TextField
                {...field}
                inputRef={ref}
                id="courseContent"
                type="text"
                fullWidth
                error={!!errors.course_content}
                label="Course Content Overview"
                helperText={errors?.course_content?.message}
                InputProps={{
                  sx: {
                    ...FormStyle.inputStyle,
                  },
                }}
              />
            )}
          />
        </Box>

        {/* Dynamic Modules */}
        {moduleFields.map((module, moduleIndex) => (
          <Box
            key={module.id}
            sx={{
              width: "100%",
              backgroundColor: "white",
              borderRadius: "1rem",
              p: 2,
              my: 2,
            }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="h6">Module {moduleIndex + 1}</Typography>
              <Button
                variant="contained"
                color="error"
                onClick={() => removeModuleField(moduleIndex)}
                disabled={moduleFields.length <= 1}
              >
                Remove Module
              </Button>
            </Box>

            {/* Module Title */}
            <Box sx={{ my: 2 }}>
              <Controller
                name={`modules.${moduleIndex}.title`}
                control={control}
                defaultValue={module.title}
                rules={{
                  required: {
                    value: true,
                    message: "*Module title is required",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="Module Title"
                    error={!!errors.modules?.[moduleIndex]?.title}
                    helperText={errors.modules?.[moduleIndex]?.title?.message}
                    InputProps={{
                      sx: {
                        ...FormStyle.inputStyle,
                      },
                    }}
                  />
                )}
              />
            </Box>

            {/* Module Total Hours */}
            <Box sx={{ my: 2 }}>
              <Controller
                name={`modules.${moduleIndex}.totalHours`}
                control={control}
                defaultValue={module.totalHours}
                rules={{
                  required: {
                    value: true,
                    message: "*Module Total Hours is required",
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    label="Module Total Hours"
                    error={!!errors.modules?.[moduleIndex]?.totalHours}
                    helperText={
                      errors.modules?.[moduleIndex]?.totalHours?.message
                    }
                    InputProps={{
                      sx: {
                        ...FormStyle.inputStyle,
                      },
                    }}
                  />
                )}
              />
            </Box>

            {/* Module Items */}
            <ModuleItemsManager
              control={control}
              moduleIndex={moduleIndex}
              items={module.items}
            />
          </Box>
        ))}

        <Box sx={{ my: 2 }}>
          <Button variant="contained" onClick={addNewModule}>
            Add New Module
          </Button>
        </Box>

        {/* Course Includes */}
        <Typography variant="h6" className="my-2">
          Course Includes
        </Typography>
        <QuillEditor quillRef={courseIncludeRef} />
        {courseIncludeRef?.current?.getEditor()?.getLength() == 1 && (
          <FormHelperText sx={{ color: "red" }}>
            *Course Include Required
          </FormHelperText>
        )}

        {/* Description */}
        <Typography variant="h6" className="my-2">
          Description
        </Typography>
        <QuillEditor quillRef={quillRef} />
        {quillRef?.current?.getEditor()?.getLength() == 1 && (
          <FormHelperText sx={{ color: "red" }}>
            *Description Required
          </FormHelperText>
        )}

        {/* Requirement */}
        <Typography variant="h6" className="my-2">
          Requirement
        </Typography>
        <QuillEditor quillRef={requirementRef} />
        {requirementRef?.current?.getEditor()?.getLength() == 1 && (
          <FormHelperText sx={{ color: "red" }}>
            *Requirement Required
          </FormHelperText>
        )}

        {/* your_learn */}
        <Box
          sx={{
            width: "100%",
            backgroundColor: "white",
            borderRadius: "1rem",
            p: 2,
            my: 2,
          }}
        >
          <Typography variant="h6">What You Will Learn</Typography>

          <Box sx={{ width: "100%", mb: 2 }}>
            {fieldList.map((field, index) => (
              <Controller
                key={field.id}
                name={`your_learn[${index}].name`}
                control={control}
                defaultValue={field.name} //insert props.content
                rules={{
                  required: {
                    value: true,
                    message: "*Text is required",
                  },
                  validate: () => {
                    // Get the entire description array
                    const your_learn = getValues("your_learn");
                    const totalLength = your_learn.reduce(
                      (acc, curr) => acc + (curr.name?.length || 0),
                      0
                    );

                    // Maximum combined character count
                    const maxCombinedLength = 500;

                    return (
                      totalLength <= maxCombinedLength ||
                      ` The combined total must not exceed ${maxCombinedLength} characters`
                    );
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    id={`your_learn[${index}].name`}
                    type="text"
                    variant="standard"
                    fullWidth
                    size="large"
                    error={!!errors?.your_learn?.[index]?.name}
                    label={
                      <Typography variant="h5">
                        Enter field {index + 1}
                        {!!errors?.your_learn?.[index]?.name === true && (
                          <small>
                            {errors.your_learn?.[index]?.name.message}
                          </small>
                        )}
                      </Typography>
                    }
                    sx={{ bgcolor: "rgb(231 239 254)", mt: "2rem" }}
                  />
                )}
              />
            ))}
          </Box>
          {fieldList.length < 10 && (
            <Button variant="contained" sx={{ mr: 5 }} onClick={addField}>
              Add
            </Button>
          )}

          <Button variant="contained" onClick={removeField}>
            Remove
          </Button>
        </Box>

        {/* Active/Inactive Toggle */}
        <Box sx={{ my: 3 }}>
          <Controller
            name="status"
            control={control}
            defaultValue={props.edit === "edit" ? props.editPost.is_active : ""}
            render={({ field }) => (
              <FormControlLabel
                control={
                  <Switch
                    {...field}
                    checked={field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                  />
                }
                label={field.value ? "Active" : "Inactive"}
              />
            )}
          />
        </Box>

        <Box display={"flex"} justifyContent="right">
          <Button
            id="btnSave"
            type="submit"
            variant="contained"
            disabled={loading ? true : false}
            sx={{
              color: "#000",
              bgcolor: "#2196f3",
              mt: 3,
              "&:hover": {
                bgcolor: "white",
              },
            }}
          >
            {loading ? (
              <CircularProgress
                sx={{ width: "50%", color: "white", m: "0 auto" }}
              ></CircularProgress>
            ) : props.edit !== "" ? (
              "Update"
            ) : (
              "Confirm"
            )}
          </Button>
        </Box>
      </form>
    </>
  );
}

export default RecordingCourseForm;
